import { render, staticRenderFns } from "./ObstacleList.vue?vue&type=template&id=231d4dc8&"
import script from "./ObstacleList.vue?vue&type=script&lang=js&"
export * from "./ObstacleList.vue?vue&type=script&lang=js&"
import style0 from "./ObstacleList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports